import React from 'react';
import {get} from './Storage';
import Toolbar from "./Toolbar";

// Tabs
import TabProfile from './TabProfile';
import TabNews from './TabNews';
import TabCoupon from './TabCoupon';
import TabPanel from './TabPanel';
import PropTypes from 'prop-types';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TabsComponent';

import { SwitchTheme } from "mgUiKit";

/*CSS Styles Radium*/
var styles = AppSettings.styles;

class MGTabsComponent extends React.Component {

    constructor(props, context) {
        super(props);
        this.state = {
            dataNews: [],
            countNews: context.countNews,
            countCoupon: context.countCoupon,
            alertProfile: props.alertProfile,
            defaultTab: props.defaultTab,
            tabContainer: "",
            checkedTheme: false,            
            countMission: context.countMission
        }
        this.loadTab = this.loadTab.bind(this);
        this.updateTabsCount = this.updateTabsCount.bind(this);
        this.handleChange = this.handleChange.bind(this);
       // this.loadTab = this.loadTab.bind(this);
        this.loadTabProfile = this.loadTabProfile.bind(this);
        this.loadTabNews = this.loadTabNews.bind(this);
        this.loadTabCoupon = this.loadTabCoupon.bind(this);
        //this.loadTabPanel = this.loadTabPanel.bind(this);
    }

    componentDidMount() {
        var defaultTab = this.props.defaultTab;
        this.loadTab(defaultTab);
    }

    getChildContext() {
        return {
            updateTabsCount: this.updateTabsCount
        };
    }

    componentDidUpdate(prevProps){
        if (prevProps.alertProfile !== this.props.alertProfile) {
            this.setState({
                alertProfile: this.props.alertProfile
            });
        }
    }

    updateTabsCount(type, count) {
        if (type == 'news') {
            this.setState({
                countNews: count
            });
        }

        if (type == 'coupon') {
            this.setState({
                countCoupon: count
            });
        }
    }

    handleChange(value) {
        this.loadTab(value);
    }

    loadTab(value) {
        this.setState({
            defaultTab: value
        });
        if (value == 'profile') {
            this.loadTabProfile();
        }

        if (value == 'news') {
            this.loadTabNews();
        }

        if (value == 'coupon') {
            this.loadTabCoupon();
        }
       /* if (value == 'panel' && AppSettings['isPartner']) {
            this.loadTabPanel();
        }*/
    }

    loadTabProfile() {       
        var tab = <TabProfile countMission={this.state.countMission} />;       
        this.setState({
            tabContainer: tab
        });
    }

    loadTabNews() {
        var tab = <TabNews  />;
        this.setState({
            tabContainer: tab
        });
    }

    loadTabCoupon(){
        var tab = <TabCoupon />;
        this.setState({
            tabContainer: tab
        });
    }


  /*  loadTabPanel() {
        var tab = <TabPanel />;
        this.setState({
            tabContainer: tab
        });
    }*/

    // handleSwitchTheme(theme){
    //     this.context.switchTheme(theme);
    // }

    render() {
         
        // var switchThemeAttribute = {
        //     on: this.state.checkedTheme,
        //     small:true,
        //     callBack: this.handleSwitchTheme.bind(this)
        // };
        
        
       return (
            <div id="mg-user-box-wrap">
                <Toolbar 
                    alertProfile={this.state.alertProfile} 
                    countCoupon={this.state.countCoupon}
                    countNews={this.state.countNews} data={this.props.toolbarData}
                    showFooter={false} handleTab={this.loadTab} initialTabActive={this.state.defaultTab}
                    countMission={this.state.countMission}
                />  
                <div id="mg-user-tabs-wrap">
                    {this.state.tabContainer}                  
                </div>
                <div id="mg-user-version">
                    <span className="version"> v{AppSettings.version}</span>
               </div>
            
            </div>
            
        )
    }
}

MGTabsComponent.displayName = componentName;

// PropTypes validation
MGTabsComponent.propTypes = {
    defaultTab: PropTypes.string.isRequired,
    alertProfile: PropTypes.bool,
};

// default props
MGTabsComponent.defaultProps = {
    defaultTab: "profile",
    alertProfile: false
};

MGTabsComponent.contextTypes = {
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    switchTheme: PropTypes.func,
    countMission: PropTypes.number
}
MGTabsComponent.childContextTypes = {
    updateTabsCount: PropTypes.func,
    
}

export default  MGTabsComponent;